var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "container", staticClass: "container root" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("div", [
        _c("h1", [_vm._v("\n        Baixe o nosso novo aplicativo.\n      ")])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "imgs" }, [
          _c("div", [
            _c("p", [
              _vm._v(
                "\n            Tenha acesso direto ao perfil do profissional, receba promoções, novidades e muito mais.\n          "
              )
            ]),
            _vm._v(" "),
            _c("img", {
              attrs: {
                src: require("../../../static/dashboard/app.svg"),
                width: "120"
              }
            })
          ]),
          _vm._v(" "),
          _c("img", {
            staticClass: "mobile-img",
            attrs: { src: require("../../../static/app-2.png") }
          })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "right" }, [
      _c("img", {
        staticClass: "desktop-img",
        attrs: { src: require("../../../static/app-2.png") }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b257bd38", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b257bd38","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/Index.vue
// module id = null
// module chunks = 